<template>

    <main class="articles">

        <section class="articles__hero">

            <div class="container">

                <span class="articles__eyebrow uppercase">
                    {{ 'articles_eyebrow' | staticTitle }}
                </span>

                <h1>
                    {{ 'articles_header' | staticTitle }}
                </h1>

                <p>
                    {{ 'articles_header' | staticContent }}
                </p>

            </div>

        </section>

        <section class="articles__list">

            <div class="container">

                <div class="articles__grid">

                    <article
                        v-for="(article, index) in articles"
                        :key="index"
                        class="article-card"
                    >

                        <img
                            :src="article.hash | staticImg"
                            :alt="article.hash | staticTitle"
                        >

                        <div class="article-card__content">

                            <span class="article-card__date">
                                {{ article.dateHash | staticTitle }}
                            </span>

                            <h2>
                                {{ article.hash | staticTitle }}
                            </h2>

                            <p>
                                {{ article.hash | staticContent }}
                            </p>

                            <router-link :to="article.route">
                                {{ 'articles_read_more' | staticTitle }}
                            </router-link>

                        </div>

                    </article>

                </div>

            </div>

        </section>

    </main>

</template>

<script>
export default {
    name: 'Articles',

    data() {
        return {
            articles: [
                {
                    hash: 'article_1',
                    dateHash: 'article_1_date',
                    route: '/articles/article-one'
                },
                {
                    hash: 'article_2',
                    dateHash: 'article_2_date',
                    route: '/articles/article-two'
                },
                {
                    hash: 'article_3',
                    dateHash: 'article_3_date',
                    route: '/articles/article-three'
                }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.articles {
    background: var(--gray-100);

    &__hero {
        padding: 7.5em 1.25em 4.375em;
        text-align: center;
        background: var(--dark);

        h1 {
            max-width: 5em;
            margin: 0 auto 1.25em;
            color: var(--white);
            font-size: clamp(2.5em, 7vw, 4.375em);
            line-height: 1.05;
        }

        p {
            max-width: 43.75em;
            margin: 0 auto;
            color: var(--text-muted);
            font-size: 1.0625em;
            line-height: 1.8;
        }
    }

    &__eyebrow {
        display: inline-block;
        margin-bottom: 1em;
        color: var(--primary);
        font-size: 0.75em;
        font-weight: 700;
        -letter-spacing: 0.1875em;
    }

    &__list {
        padding: 4.375em 1.25em;
    }

    &__grid {
        display: grid;
        grid-template-columns: 1fr;
        gap: 1.5em;
    }
}

.article-card {
    overflow: hidden;
    background: var(--white);
    border: 0.0625em solid var(--gray-200);
    border-radius: 1.125em;
    transition: var(--transition);

    img {
        display: block;
        width: 100%;
        aspect-ratio: 16 / 10;
        object-fit: cover;
    }

    &__content {
        padding: 1.5em;
    }

    &__date {
        display: block;
        margin-bottom: 0.625em;
        color: var(--primary);
        font-size: 0.8125em;
        font-weight: 600;
    }

    h2 {
        margin: 0 0 0.875em;
        color: var(--dark);
        font-size: 1.5em;
        line-height: 1.2;
    }

    p {
        margin: 0 0 1.25em;
        color: var(--gray-600);
        line-height: 1.7;
    }

    a {
        color: var(--primary);
        text-decoration: none;
        font-weight: 600;
        transition: var(--transition);

        &:hover {
            color: var(--primary-hover);
        }
    }

    &:hover {
        transform: translateY(-0.3125em);
        box-shadow: 0 1.125em 2.5em rgba(0, 0, 0, .08);
    }
}

@media (min-width: 48em) {
    .articles {

        &__list {
            padding: 5.625em 1.25em;
        }

        &__grid {
            grid-template-columns: repeat(2, 1fr);
        }
    }
}

@media (min-width: 64em) {
    .articles {

        &__grid {
            grid-template-columns: repeat(3, 1fr);
        }
    }
}
</style>